import type { ZoneResponse } from 'api/__GENERATED';
import { apiUtility, domainUtility } from 'utility';

import { toZone } from './toZone';

// Builds a normalized `Data.Zone` domain from a list of Zone DTOs.
function toZoneDomain(args: { dtos: ZoneResponse[] }) {
  const { dtos } = args;

  const zoneDomain: NormalizedDomain<Data.Zone> = {
    allIds: [],
    byId: {},
  };

  apiUtility.iterator({
    list: dtos,
    transformer: (item) => {
      const zone = toZone(item);
      domainUtility.mutateAdd(zoneDomain, zone);
    },
  });

  return { zoneDomain };
}

export { toZoneDomain };
